"use client"

import { use$ } from "@legendapp/state/react"
import { useEffect, useRef } from "react"
import { usePostHog } from "posthog-js/react"
import { syncStore$ } from "@/stores/sync.v2.store"
import { getAuthenticatedPostHogIdentitySignature, identifyAuthenticatedPostHogUser, reconcileUnauthenticatedPostHogIdentity, shouldIdentifyAuthenticatedPostHogUser } from "@/lib/posthog/identity"

export function usePosthogIdentified(authoritativeDistinctId: string | null) {
  const posthog = usePostHog()
  const user = use$(syncStore$.userStatus)
  const account = use$(syncStore$.account)
  const lastIdentitySignatureRef = useRef<string | null>(null)

  useEffect(() => {
    const syncDistinctId = user?.id.toString() ?? null

    if (user && shouldIdentifyAuthenticatedPostHogUser(authoritativeDistinctId, syncDistinctId)) {
      const identitySignature = getAuthenticatedPostHogIdentitySignature(user, account)

      if (identitySignature === lastIdentitySignatureRef.current) {
        return
      }

      const storage = typeof window !== "undefined" ? window.localStorage : null
      identifyAuthenticatedPostHogUser({
        account,
        client: posthog,
        storage,
        user,
      })
      lastIdentitySignatureRef.current = identitySignature
    } else if (!authoritativeDistinctId) {
      const storage = typeof window !== "undefined" ? window.localStorage : null
      reconcileUnauthenticatedPostHogIdentity({ client: posthog, storage })
      lastIdentitySignatureRef.current = null
    }
  }, [account, authoritativeDistinctId, user, posthog])
}
